import React, { Component } from 'react'
import GraphiQL from 'graphiql'
import fetch from 'isomorphic-fetch'
import { compose, graphql, Mutation } from 'react-apollo'
import { Menu } from 'semantic-ui-react'

import { findFeedsForApi } from '../../all_cards/aufschaltung.js'

import { 
  MutationUpdatePreferences,
  MutationUpdatePreferencesFromCache } from '../../graphql'

class ApiGraphqlBrowser extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeItem: 0,
      gql_query: null,
      trigger_update_preferences: false
    }
  }

  componentDidMount () {
    this.setState({gql_query: this.get_graphql_query()})
    this.query_changed = false
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.activeItem !== prevState.activeItem) {
      this.setState({gql_query: this.get_graphql_query()})
    }
  }

  graphQLFetcher = (params) => {
    const feed = this.get_active_feed()
    const graphql_endpoint_url = feed && feed.graphql_endpoint_url

    if (this.query_changed) {
      // send changes to server immediately
      const { updatePreferences } = this.props
      this.update_preferences(updatePreferences)
      this.query_changed = false
    }

    return fetch(graphql_endpoint_url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
    }).then(response => response.json())
  }

  handleItemClick = ({ index }) => {
    if (this.state.activeItem !== index) {
      this.setState({activeItem: index})
    }
  }

  get_active_feed () {
    const feeds = this.find_feeds()
    return feeds && feeds[this.state.activeItem]
  }

  get_api_from_context() {
    const { context } = this.props
    return (context && context.navigation && context.navigation.api) || 'graphql'
  }

  find_feeds() {
    const { context } = this.props
    const api = this.get_api_from_context()
    return api && findFeedsForApi(context, api)
  }

  get_graphql_query () {
    const { context } = this.props
    const { preferences } = context

    const state = JSON.parse(preferences ? preferences.state : null)
    const current_gql_queries = (state && state.graphql_queries) ? state.graphql_queries : null

    const api = this.get_api_from_context()
    const activeFeed = this.get_active_feed()
    // hoechste prio: das letzte vom user editierte query
    // naechste prio: graphql_example_query aus dem aufschaltungs-feed
    return (current_gql_queries && current_gql_queries[api])
      ? current_gql_queries[api]
      : ((activeFeed && activeFeed.graphql_example_query) || '')
  }

  update_preferences (update_mutation) {
    const { gql_query } = this.state
    let gql_queries = {}
    gql_queries[this.get_api_from_context()] = gql_query

    // Update preferences with new api query (only changes)
    const vars = {
      lang: null,
      state: JSON.stringify({graphql_queries: gql_queries})
    }
    update_mutation({variables: vars})
    this.setState({trigger_update_preferences: false})
  }

  onEditQuery = (query) => {
    /**
     * Called whenever the query text has changed
     */
    if (!this.query_changed) {
      this.query_changed = true
    }
    let gql_queries = {}
    gql_queries[this.get_api_from_context()] = query
    this.setState({gql_query: query, trigger_update_preferences: true})
  }

  render () {
    const feeds = this.find_feeds()
    if (!feeds) {
      return <div>Keine Ergebnisse</div>
    }

    const { activeItem, gql_query, trigger_update_preferences } = this.state
    return (
      <div>
        <Menu pointing secondary>
          { feeds.map((feed, i) => {
            return (
              <Menu.Item name={feed.nickname} index={i} active={activeItem === i}
                onClick={ ({index}) => this.handleItemClick({index}) } />
            )
          })
          }
        </Menu>
        <Mutation mutation={MutationUpdatePreferencesFromCache}>
          {(updatePreferences, {error}) => {
            if (error) return `Error!: ${error}`

            if (trigger_update_preferences) {
              // Handle the mutation call not in this.onEditQuery due to
              // side-effects like jumping cursor while typing
              this.update_preferences(updatePreferences)
            }

            return (
              <GraphiQL query={gql_query}
                        fetcher={this.graphQLFetcher}
                        editorTheme='ttcn'
                        onEditQuery={this.onEditQuery}
              />
            )
          }}
        </Mutation>
      </div>
    )
  }
}

export default compose(
  graphql(
    MutationUpdatePreferences,
    { name: 'updatePreferences' }
  )
)(ApiGraphqlBrowser)



// WEBPACK FOOTER //
// ./src/components/cards/ApiGraphqlBrowser.js